import styled, { css, keyframes } from 'styled-components';
import { colors, easing } from 'ui/theme';

export const ProgressSpinnerContainer = styled.div<{ $width: number; progress: number }>`
  display: flex;
  box-sizing: border-box;
  background: linear-gradient(
    30deg,
    #ff4d80,
    #fe4d81,
    #fc4e82,
    #f95086,
    #f4528a,
    #ee5490,
    #e65897,
    #de5b9f,
    #d65fa7,
    #ce62af,
    #c666b6,
    #c068bc,
    #bb6ac0,
    #b86cc4,
    #b66dc5,
    #b56dc6
  );

  width: ${({ $width }) => $width}px;
  height: ${({ $width }) => $width}px;
  position: relative;
  border-radius: 50%;
  padding: 2px;
`;

export const Progress = styled.div<{ progress?: number; duration?: number }>`
  --progress: ${({ progress, duration }) => (duration ? 0 : progress)}%;
  --remaining: ${({ progress }) => (progress ? 100 - progress : 100)}%;
  background: conic-gradient(transparent var(--progress), 0, ${colors.grey10} var(--remaining));
  position: absolute;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  top: -1px;
  left: -1px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid ${colors.white};

  ${({ duration }) =>
    duration &&
    css`
      animation: progress-spin ${duration}s ${easing.standard} infinite,
        progress-spin2 ${duration}s ${easing.standard} infinite;
    `}

  @keyframes progress-spin {
    to {
      --progress: 100%;
    }
  }

  @keyframes progress-spin2 {
    to {
      --remaining: 0%;
    }
  }

  @property --progress {
    syntax: '<percentage>';
    inherits: true;
    initial-value: 0%;
  }

  @property --remaining {
    syntax: '<percentage>';
    inherits: true;
    initial-value: 100%;
  }
`;

const bouncyRotate = keyframes`
    80% {
        transform: rotate(90deg);
    }
    85%{
        transform: rotate(135deg);
    }
    90%{
        transform: rotate(45deg);
    }
    100% {
        transform: rotate(90deg);
    }
`;

export const Sparkle = styled.div`
  background: ${colors.white};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  animation: ${bouncyRotate} 2000ms infinite;
`;
